import { __decorate } from "tslib";
import { Prop, Mixins, Component } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ActionButton from '@/components/action_button/Index.vue';
import PhoneInput from '@/components/v2/PhoneInput.vue';
import { required } from 'vuelidate/lib/validators';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import updateSupportDetails from '@/plugins/graphql/mutations/v2/update-support-details.gql';
let SupportDetailsDialog = class SupportDetailsDialog extends Mixins(ViewportSizeMixin, FormMixin, FormValidationsMixin) {
    constructor() {
        super(...arguments);
        this.show = true;
        this.mutationRequestOnFlight = false;
        this.form = {
            supportEmailList: null,
            supportContactNumber: null,
        };
    }
    hideDialog() {
        this.show = false;
    }
    onSubmit() {
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }
        this.mutationRequestOnFlight = true;
        this.$apollo
            .mutate({
            mutation: updateSupportDetails,
            variables: {
                input: {
                    appUuid: this.appUuid,
                    supportEmailList: this.form.supportEmailList.toString(),
                    supportContactNumber: this.form.supportContactNumber,
                },
            },
        })
            .then(() => {
            this.successNotification(`Email Verification Sent`);
            this.hideDialog();
        })
            .catch(() => {
            this.errorNotification('Error Updating App Support Contact Details');
        })
            .finally(() => {
            this.mutationRequestOnFlight = false;
            this.hideDialog();
        });
    }
};
__decorate([
    Prop({ type: String, default: '' })
], SupportDetailsDialog.prototype, "appUuid", void 0);
SupportDetailsDialog = __decorate([
    Component({
        components: {
            ActionButton,
            PhoneInput,
        },
        validations: {
            form: {
                supportEmailList: {
                    required,
                },
                supportContactNumber: {},
            },
        },
    })
], SupportDetailsDialog);
export default SupportDetailsDialog;
